var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accessory-cost tb"},[_c('custom-tab',{attrs:{"list":_vm.tabData},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}}),(_vm.tabIndex === 0)?_c('costs'):_vm._e(),(_vm.tabIndex === 1)?_c('share'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }